document.addEventListener('DOMContentLoaded', function() {
  try {
    // Step navigation elements
    const formSteps = document.querySelectorAll('.form-step');
    const stepIndicators = document.querySelectorAll('.step');
    const prevBtn = document.getElementById('prev-button');
    const nextBtn = document.getElementById('next-button');
    const submitBtn = document.getElementById('submit-button');
    
    // Check if we're on the right page
    if (!formSteps.length || !prevBtn || !nextBtn || !submitBtn) {
      console.log('Bridal shower form elements not found, skipping initialization');
      return;
    }
    
    console.log('Found form navigation buttons:', { 
      prevBtn: prevBtn ? 'exists' : 'missing', 
      nextBtn: nextBtn ? 'exists' : 'missing', 
      submitBtn: submitBtn ? 'exists' : 'missing'
    });
    
    // Form data elements
    const bridalForm = document.getElementById('bridal-shower-form');
    const brideName = document.getElementById('bride-name');
    const eventDate = document.getElementById('event-date');
    const invitationDesign = document.getElementById('invitation-design');
    const filePreview = document.querySelector('.file-preview');
    const filePreviewImage = document.getElementById('file-preview-image');
    const fileNameDisplay = document.getElementById('file-name');
    const totalQuantity = document.getElementById('total-quantity');
    const pricePerJar = document.getElementById('price-per-jar');
    const totalPrice = document.getElementById('total-price');
    const scentAllocation = document.getElementById('scent-allocation');
    const progressBar = document.querySelector('.progress-bar');
    const allocatedQty = document.getElementById('allocated-qty');
    const remainingQty = document.getElementById('remaining-qty');
    const allocationSummary = document.getElementById('allocation-summary');
    
    // Variables
    let currentStep = 0;
    const MINIMUM_QUANTITY = parseInt(totalQuantity?.getAttribute('min')) || 25;
    const BASE_PRICE = 12.00; // Base price per jar
    let uploadedFile = null;
    
    // Initialize the form
    initForm();
    
    // Form initialization
    function initForm() {
      console.log("Initializing bridal shower form");
      
      // Try both hardcoded and section-based product ID methods
      ensureProductId();
      
      // Try to use the fallback variant selector if needed
      checkAndUseFallbackVariantSelector();
      
      // Set minimum date to tomorrow if event date exists
      if (eventDate) {
        const tomorrow = new Date();
        tomorrow.setDate(tomorrow.getDate() + 1);
        eventDate.min = tomorrow.toISOString().split('T')[0];
      }
      
      // Set initial quantity if element exists
      if (totalQuantity) {
        totalQuantity.value = MINIMUM_QUANTITY;
        
        // Add event listeners for quantity changes
        totalQuantity.addEventListener('input', updatePricing);
        totalQuantity.addEventListener('change', updatePricing);
        
        // Update actual quantity input
        const actualQuantityInput = document.getElementById('actual-quantity');
        if (actualQuantityInput) {
          actualQuantityInput.value = MINIMUM_QUANTITY;
        }
      }
      
      // Initialize price display
      updatePricing();
      
      // Initialize scent quantity inputs
      document.querySelectorAll('.scent-quantity-input').forEach(input => {
        input.addEventListener('input', updateAllocationProgress);
        input.addEventListener('change', validateQuantityInput);
      });
      
      // Set up navigation buttons
      if (prevBtn) {
        console.log("Adding click handler to previous button");
        prevBtn.addEventListener('click', goToPreviousStep);
      }
      
      if (nextBtn) {
        console.log("Adding click handler to next button");
        nextBtn.addEventListener('click', function(e) {
          e.preventDefault();
          console.log("Next button clicked");
          goToNextStep();
        });
      }
      
      // File upload preview
      if (invitationDesign) {
        invitationDesign.addEventListener('change', handleFileUpload);
      }
      
      // Main quantity buttons
      const mainDecreaseBtn = document.querySelector('.quantity-selector .quantity-decrease');
      const mainIncreaseBtn = document.querySelector('.quantity-selector .quantity-increase');
      
      if (mainDecreaseBtn) {
        mainDecreaseBtn.addEventListener('click', decreaseQuantity);
      }
      
      if (mainIncreaseBtn) {
        mainIncreaseBtn.addEventListener('click', increaseQuantity);
      }
      
      // Scent quantity buttons - these need separate handling
      document.querySelectorAll('.scent-quantity').forEach(container => {
        const decreaseBtn = container.querySelector('.quantity-decrease');
        const increaseBtn = container.querySelector('.quantity-increase');
        const input = container.querySelector('.scent-quantity-input');
        
        if (decreaseBtn && input) {
          decreaseBtn.addEventListener('click', function() {
            decreaseScentQuantity(input);
          });
        }
        
        if (increaseBtn && input) {
          increaseBtn.addEventListener('click', function() {
            increaseScentQuantity(input);
          });
        }
      });
      
      // Form submission
      if (bridalForm) {
        bridalForm.addEventListener('submit', prepareFormSubmission);
      }
      
      // Show first step
      showStep(0);
      
      console.log("Bridal shower form initialized successfully");
    }
    
    // Ensure we have a product ID by trying multiple approaches
    function ensureProductId() {
      // Default bridal shower product ID if needed
      const DEFAULT_PRODUCT_ID = "bridal-shower-mini-scrub";
      
      // Check if we already have a product ID
      let productIdInput = document.querySelector('input[name="id"]');
      const bridalProductIdInput = document.getElementById('bridal-product-id');
      
      // If no product ID, try to find one from the debug info
      if (!productIdInput || !productIdInput.value || productIdInput.value.trim() === '') {
        console.log("Looking for product ID from section settings or debug info");
        
        // Try to get product from data attributes
        const debugElement = document.querySelector('[data-debug-product-id]');
        if (debugElement) {
          const debugText = debugElement.textContent;
          if (debugText && debugText.includes("Product ID")) {
            const idMatch = debugText.match(/Product ID.*?(\d+)/);
            if (idMatch && idMatch[1]) {
              console.log("Found product ID from debug:", idMatch[1]);
              createOrUpdateProductIdInput(idMatch[1]);
              return;
            }
          }
        }
        
        // Try to get from product ID from debugger element
        const products = document.querySelectorAll('.product-debug-info');
        if (products && products.length > 0) {
          const firstProduct = products[0];
          const variantIdElement = firstProduct.querySelector('p');
          if (variantIdElement && variantIdElement.textContent.includes("Variant ID")) {
            const variantIdText = variantIdElement.textContent;
            const variantIdMatch = variantIdText.match(/Variant ID:\s*(\d+)/);
            if (variantIdMatch && variantIdMatch[1]) {
              console.log("Found variant ID from debug:", variantIdMatch[1]);
              createOrUpdateProductIdInput(variantIdMatch[1]);
              return;
            }
          }
        }
        
        // Try fallback to hardcoded product
        console.log("Using hardcoded default product ID:", DEFAULT_PRODUCT_ID);
        
        // Find all product with Bridal Shower in the name
        const bridalProducts = Array.from(document.querySelectorAll('.scent-card')).filter(card => {
          const name = card.querySelector('.scent-name');
          return name && name.textContent.includes('Bridal');
        });
        
        // If found, use the first one
        if (bridalProducts.length > 0) {
          const firstBridalProduct = bridalProducts[0];
          const idElement = firstBridalProduct.querySelector('.product-debug-info p');
          if (idElement) {
            const idMatch = idElement.textContent.match(/Product ID:\s*(\d+)/);
            if (idMatch && idMatch[1]) {
              console.log("Found bridal product ID:", idMatch[1]);
              createOrUpdateProductIdInput(idMatch[1]);
              return;
            }
          }
        }
      } else {
        console.log("Form already has a product variant ID:", productIdInput.value);
      }
    }
    
    // Create or update product ID inputs
    function createOrUpdateProductIdInput(variantId) {
      if (!variantId) return;
      
      // Update or create the main product ID input
      let productIdInput = document.querySelector('input[name="id"]');
      if (!productIdInput) {
        productIdInput = document.createElement('input');
        productIdInput.type = 'hidden';
        productIdInput.name = 'id';
        
        const formElement = document.getElementById('bridal-shower-form');
        if (formElement) {
          formElement.appendChild(productIdInput);
        }
      }
      
      if (productIdInput) {
        productIdInput.value = variantId;
      }
      
      // Also update the bridal-product-id input if it exists
      const bridalProductId = document.getElementById('bridal-product-id');
      if (bridalProductId) {
        bridalProductId.value = variantId;
      }
    }
    
    // File upload handler
    function handleFileUpload(e) {
      const file = e.target.files[0];
      if (!file) {
        filePreview.style.display = 'none';
        uploadedFile = null;
        return;
      }
      
      uploadedFile = file;
      fileNameDisplay.textContent = file.name;
      
      // Show preview for images
      if (file.type.startsWith('image/')) {
        const reader = new FileReader();
        reader.onload = function(e) {
          filePreviewImage.src = e.target.result;
          filePreviewImage.style.display = 'block';
        };
        reader.readAsDataURL(file);
      } else {
        // For non-images (like PDFs)
        filePreviewImage.style.display = 'none';
      }
      
      filePreview.style.display = 'block';
    }
    
    // Step navigation functions
    function showStep(stepIndex) {
      // Make sure we have valid step index
      if (stepIndex < 0 || stepIndex >= formSteps.length) {
        console.error(`Invalid step index: ${stepIndex}`);
        return;
      }
      
      // Log for debugging
      console.log(`Showing step ${stepIndex}`);
      
      // Update form steps visibility
      formSteps.forEach((step, index) => {
        step.classList.toggle('active', index === stepIndex);
      });
      
      // Update step indicators
      stepIndicators.forEach((indicator, index) => {
        indicator.classList.toggle('active', index === stepIndex);
        indicator.classList.toggle('completed', index < stepIndex);
      });
      
      // Control button visibility
      prevBtn.style.display = stepIndex === 0 ? 'none' : 'block';
      nextBtn.style.display = stepIndex === formSteps.length - 1 ? 'none' : 'block';
      submitBtn.style.display = stepIndex === formSteps.length - 1 ? 'block' : 'none';
      
      // Special handling for allocation step
      if (stepIndex === 1) {
        updateAllocationProgress();
      }
      
      // Update summary if on the review step
      if (stepIndex === formSteps.length - 1) {
        updateOrderSummary();
      }
      
      // Update current step tracking
      currentStep = stepIndex;
    }
    
    function goToPreviousStep() {
      console.log("Previous button clicked, current step:", currentStep);
      if (currentStep > 0) {
        showStep(currentStep - 1);
      }
    }
    
    function goToNextStep() {
      console.log("Next button clicked, current step:", currentStep);
      
      // Validate current step
      const isValid = validateCurrentStep();
      console.log(`Step ${currentStep} validation result:`, isValid);
      
      if (isValid) {
        if (currentStep < formSteps.length - 1) {
          console.log(`Moving to step ${currentStep + 1}`);
          showStep(currentStep + 1);
        } else {
          console.log("Already at the last step, can't go further");
        }
      } else {
        console.log("Validation failed, staying on current step");
      }
    }
    
    // Validation functions
    function validateCurrentStep() {
      let isValid = true;
      
      try {
        switch(currentStep) {
          case 0:
            // Validate bride info and event date
            console.log("Validating bride info step");
            console.log("Bride name:", brideName?.value);
            console.log("Event date:", eventDate?.value);
            
            if (!brideName || !brideName.value || brideName.value.trim() === '') {
              if (brideName) showError(brideName, 'Please enter the bride\'s name');
              console.error("Bride name validation failed - empty or missing");
              isValid = false;
            }
            
            if (!eventDate || !eventDate.value) {
              if (eventDate) showError(eventDate, 'Please select an event date');
              console.error("Event date validation failed - empty or missing");
              isValid = false;
            }
            break;
            
          case 1:
            // Validate quantity and scent allocation
            console.log("Validating scent selection step");
            const qty = totalQuantity ? parseInt(totalQuantity.value) : 0;
            const allocated = getAllocatedQuantity();
            
            console.log("Total quantity:", qty);
            console.log("Allocated quantity:", allocated);
            console.log("Minimum required:", MINIMUM_QUANTITY);
            
            if (!totalQuantity || qty < MINIMUM_QUANTITY) {
              if (totalQuantity) showError(totalQuantity, `Minimum quantity is ${MINIMUM_QUANTITY} jars`);
              console.error("Quantity validation failed - below minimum");
              isValid = false;
            }
            
            // Check if allocation matches total quantity
            if (allocated !== qty) {
              const allocationContainer = document.querySelector('.allocation-progress');
              if (allocationContainer) showError(allocationContainer, `You need to allocate exactly ${qty} jars`);
              console.error(`Allocation validation failed - allocated ${allocated} but total is ${qty}`);
              isValid = false;
            }
            break;
            
          default:
            console.log(`No validation needed for step ${currentStep}`);
        }
      } catch (error) {
        console.error("Validation error:", error);
        isValid = false;
      }
      
      return isValid;
    }
    
    function showError(element, message) {
      // Find or create error message element
      let errorElement = element.nextElementSibling;
      if (!errorElement || !errorElement.classList.contains('error-message')) {
        errorElement = document.createElement('div');
        errorElement.className = 'error-message';
        element.parentNode.insertBefore(errorElement, element.nextSibling);
      }
      
      errorElement.textContent = message;
      errorElement.classList.add('show');
      
      // Hide error after 3 seconds
      setTimeout(() => {
        errorElement.classList.remove('show');
      }, 3000);
    }
    
    // Quantity management
    function decreaseQuantity() {
      let qty = parseInt(totalQuantity.value);
      if (qty > MINIMUM_QUANTITY) {
        totalQuantity.value = qty - 1;
        
        // Update the actual quantity input for submission
        const actualQuantityInput = document.getElementById('actual-quantity');
        if (actualQuantityInput) {
          actualQuantityInput.value = qty - 1;
        }
        
        updatePricing();
      }
    }
    
    function increaseQuantity() {
      let qty = parseInt(totalQuantity.value);
      totalQuantity.value = qty + 1;
      
      // Update the actual quantity input for submission
      const actualQuantityInput = document.getElementById('actual-quantity');
      if (actualQuantityInput) {
        actualQuantityInput.value = qty + 1;
      }
      
      updatePricing();
    }
    
    function validateQuantityInput() {
      const input = this;
      let value = parseInt(input.value) || 0;
      
      if (value < 0) {
        input.value = 0;
      }
      
      updateAllocationProgress();
    }
    
    // Scent-specific quantity management
    function decreaseScentQuantity(input) {
      let qty = parseInt(input.value) || 0;
      if (qty > 0) {
        input.value = qty - 1;
        updateAllocationProgress();
      }
    }
    
    function increaseScentQuantity(input) {
      let qty = parseInt(input.value) || 0;
      input.value = qty + 1;
      updateAllocationProgress();
    }
    
    // Pricing functions
    function getDiscountCode(quantity) {
      if (quantity >= 100) {
        return 'BRIDAL100';
      } else if (quantity >= 50) {
        return 'BRIDAL50';
      } else if (quantity >= 25) {
        return 'BRIDAL25';
      } else {
        return 'Minimum 25 jars required';
      }
    }
    
    function updatePricing() {
      const qty = parseInt(totalQuantity.value);
      const totalPriceValue = BASE_PRICE * qty;
      const discountCode = getDiscountCode(qty);
      
      // Update price display elements - use safer DOM access with null checks
      if (pricePerJar) {
        pricePerJar.textContent = `$${BASE_PRICE.toFixed(2)}`;
      }
      
      if (totalPrice) {
        totalPrice.textContent = `$${totalPriceValue.toFixed(2)}`;
      }
      
      // Update discount code display if it exists
      const discountElement = document.getElementById('discount-code');
      if (discountElement) {
        discountElement.textContent = discountCode;
      }
      
      // For summary page - only update if on the last step
      if (currentStep === formSteps.length - 1) {
        if (document.getElementById('summary-total-qty')) {
          document.getElementById('summary-total-qty').textContent = qty;
        }
        
        if (document.getElementById('summary-price-per-jar')) {
          document.getElementById('summary-price-per-jar').textContent = `$${BASE_PRICE.toFixed(2)}`;
        }
        
        if (document.getElementById('summary-total-price')) {
          document.getElementById('summary-total-price').textContent = `$${totalPriceValue.toFixed(2)}`;
        }
      }
      
      // Update allocation progress bar if needed
      updateAllocationProgress();
    }
    
    // Scent allocation
    function updateAllocationProgress() {
      try {
        const totalQty = parseInt(totalQuantity.value) || 0;
        const allocated = getAllocatedQuantity();
        const remaining = totalQty - allocated;
        
        // Update progress bar if it exists
        if (progressBar) {
          const percentage = (allocated / totalQty) * 100;
          progressBar.style.width = `${Math.min(percentage, 100)}%`;
          progressBar.style.backgroundColor = percentage > 100 ? '#d32f2f' : '';
        }
        
        // Update text elements if they exist
        if (allocatedQty) {
          allocatedQty.textContent = allocated;
        }
        
        if (remainingQty) {
          remainingQty.textContent = remaining;
        }
        
        // Color the text based on allocation status
        const progressStatus = document.querySelector('.progress-status');
        if (progressStatus) {
          if (remaining < 0) {
            progressStatus.style.color = '#d32f2f';
          } else if (remaining === 0) {
            progressStatus.style.color = '#4caf50';
          } else {
            progressStatus.style.color = '';
          }
        }
        
        // Update allocation summary for form submission
        updateAllocationSummary();
      } catch (error) {
        console.error('Error updating allocation progress:', error);
      }
    }
    
    function getAllocatedQuantity() {
      try {
        let total = 0;
        document.querySelectorAll('.scent-quantity-input').forEach(input => {
          total += parseInt(input.value) || 0;
        });
        return total;
      } catch (error) {
        console.error('Error calculating allocated quantity:', error);
        return 0;
      }
    }
    
    function updateAllocationSummary() {
      try {
        // Skip if allocation summary doesn't exist
        if (!allocationSummary) return;
        
        // Create a summary text of the scent allocation
        let summary = '';
        document.querySelectorAll('.scent-quantity-input').forEach(input => {
          const qty = parseInt(input.value) || 0;
          if (qty > 0) {
            const scentName = input.getAttribute('data-scent-name');
            summary += `${scentName}: ${qty}, `;
          }
        });
        
        // Remove trailing comma and space
        summary = summary.replace(/, $/, '');
        
        // Update the hidden field
        allocationSummary.value = summary;
      } catch (error) {
        console.error('Error updating allocation summary:', error);
      }
    }
    
    // Order summary
    function updateOrderSummary() {
      try {
        // Update bride info - use safer DOM access with null checks
        const summaryBrideName = document.getElementById('summary-bride-name');
        if (summaryBrideName && brideName) {
          summaryBrideName.textContent = brideName.value;
        }
        
        const summaryEventDate = document.getElementById('summary-event-date');
        if (summaryEventDate && eventDate) {
          summaryEventDate.textContent = formatDate(eventDate.value);
        }
        
        // Update invitation design info
        const invitationSummary = document.getElementById('summary-invitation-design');
        if (invitationSummary) {
          if (uploadedFile) {
            invitationSummary.textContent = uploadedFile.name;
          } else {
            invitationSummary.textContent = 'None provided';
          }
        }
        
        // Update quantities and pricing
        const qty = parseInt(totalQuantity.value);
        const totalPriceValue = BASE_PRICE * qty;
        
        const summaryTotalQty = document.getElementById('summary-total-qty');
        if (summaryTotalQty) {
          summaryTotalQty.textContent = qty;
        }
        
        const summaryPricePerJar = document.getElementById('summary-price-per-jar');
        if (summaryPricePerJar) {
          summaryPricePerJar.textContent = `$${BASE_PRICE.toFixed(2)}`;
        }
        
        const summaryTotalPrice = document.getElementById('summary-total-price');
        if (summaryTotalPrice) {
          summaryTotalPrice.textContent = `$${totalPriceValue.toFixed(2)}`;
        }
        
        // Set the quantity reminder
        const quantityReminder = document.getElementById('summary-quantity-reminder');
        if (quantityReminder) {
          quantityReminder.textContent = qty;
        }
        
        // Update scent allocation - only show scents with quantity > 0
        const scentList = document.getElementById('summary-scent-list');
        if (scentList) {
          scentList.innerHTML = '';
          
          let hasScents = false;
          
          document.querySelectorAll('.scent-quantity-input').forEach(input => {
            const scentName = input.getAttribute('data-scent-name');
            const scentQty = parseInt(input.value) || 0;
            
            if (scentQty > 0) {
              hasScents = true;
              const listItem = document.createElement('div');
              listItem.className = 'summary-item summary-scent';
              listItem.innerHTML = `
                <span>${scentName}</span>
                <span>${scentQty} jars</span>
              `;
              scentList.appendChild(listItem);
            }
          });
          
          // Show message if no scents selected (shouldn't happen due to validation)
          if (!hasScents) {
            const noScentsMessage = document.createElement('div');
            noScentsMessage.className = 'summary-item';
            noScentsMessage.innerHTML = '<em>No scents selected yet. Please go back and allocate quantities.</em>';
            scentList.appendChild(noScentsMessage);
          }
        }
        
        // Update discount code
        const discountElement = document.getElementById('discount-code');
        if (discountElement) {
          discountElement.textContent = getDiscountCode(qty);
        }
      } catch (error) {
        console.error('Error updating order summary:', error);
      }
    }
    
    // Helper functions
    function formatDate(dateString) {
      const date = new Date(dateString);
      return date.toLocaleDateString('en-US', { 
        year: 'numeric', 
        month: 'long', 
        day: 'numeric' 
      });
    }
    
    // Form submission preparation
    function prepareFormSubmission(e) {
      e.preventDefault();
      
      // Show loading state
      const submitBtn = document.querySelector('.btn-submit');
      if (submitBtn) {
        submitBtn.disabled = true;
        submitBtn.textContent = 'Adding to cart...';
      }
      
      // Validate all steps
      let isValid = true;
      for (let i = 0; i < formSteps.length; i++) {
        currentStep = i;
        if (!validateCurrentStep()) {
          isValid = false;
          showStep(i);
          break;
        }
      }
      
      if (!isValid) {
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to Cart';
        }
        return;
      }
      
      console.log('Preparing form for submission...');
      
      // Get bride information
      const brideNameValue = brideName ? brideName.value : '';
      const eventDateValue = eventDate ? eventDate.value : '';
      
      // Get total quantity and pricing
      const totalQty = parseInt(totalQuantity.value);
      
      // Get scent selections - use variant IDs from the products
      const scentQuantities = [];
      
      document.querySelectorAll('.scent-quantity-input').forEach(input => {
        const qty = parseInt(input.value);
        if (qty > 0) {
          // Get the product ID directly from the data attribute
          const productId = input.dataset.productId;
          
          if (!productId) {
            console.error(`No product ID found for ${input.dataset.scentName}`);
            return;
          }
          
          // Add to our selections
          scentQuantities.push({
            name: input.dataset.scentName,
            quantity: qty,
            productId: productId
          });
        }
      });
      
      // Check that we have items
      if (scentQuantities.length === 0) {
        alert('Please select at least one scent.');
        if (submitBtn) {
          submitBtn.disabled = false;
          submitBtn.textContent = 'Add to Cart';
        }
        return;
      }
      
      console.log('Scent selections:', scentQuantities);
      
      // Common properties for all products
      const commonProperties = {
        "Bride's Name": brideNameValue,
        "Event Date": eventDateValue,
        "Bridal Shower Order": "true",
        "Total Quantity": totalQty,
        "Order Price Per Jar": `$${BASE_PRICE.toFixed(2)}`
      };
      
      // Try to add items directly to cart without clearing first
      addItemsToCart(scentQuantities, commonProperties)
        .then(success => {
          if (success) {
            window.location.href = '/cart';
          } else {
            // Re-enable submit button on failure
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = 'Add to Cart';
            }
          }
        })
        .catch(error => {
          console.error('Failed to add items to cart:', error);
          // Re-enable submit button on error
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = 'Add to Cart';
          }
        });
    }
    
    // Function to add items to cart one by one as a fallback
    async function addItemsIndividually(items, commonProperties) {
      console.log('Attempting to add items individually...');
      
      try {
        for (const item of items) {
          console.log(`Adding item: ${item.name}, quantity: ${item.quantity}, ID: ${item.productId}`);
          
          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              id: parseInt(item.productId),
              quantity: parseInt(item.quantity),
              properties: {
                ...commonProperties,
                "Scent": item.name
              }
            })
          });
          
          if (!response.ok) {
            const errorText = await response.text();
            console.error(`Error adding ${item.name} to cart:`, errorText);
            throw new Error(`Failed to add ${item.name}: ${response.status}`);
          }
          
          const data = await response.json();
          console.log(`Successfully added ${item.name} to cart:`, data);
          
          // Small delay to prevent rate limiting
          await new Promise(resolve => setTimeout(resolve, 200));
        }
        
        console.log('All items added individually successfully');
        return true;
      } catch (error) {
        console.error('Error adding items individually:', error);
        alert(`There was an error adding items to your cart: ${error.message}`);
        return false;
      }
    }
    
    // New function to add items to cart
    async function addItemsToCart(items, commonProperties) {
      console.log('Adding items to cart...');
      
      try {
        // Prepare items for cart - ensure IDs are integers
        const cartItems = items.map(item => ({
          id: parseInt(item.productId, 10), // Ensure ID is an integer
          quantity: parseInt(item.quantity, 10), // Ensure quantity is an integer
          properties: {
            ...commonProperties,
            "Scent": item.name
          }
        }));
        
        console.log('Formatted cart items:', cartItems);
        
        // Try batch add first
        try {
          const addResponse = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json'
            },
            body: JSON.stringify({
              items: cartItems
            })
          });
          
          if (!addResponse.ok) {
            const errorText = await addResponse.text();
            console.error(`Error with batch add: ${addResponse.status} ${addResponse.statusText}`, errorText);
            throw new Error(`Batch add failed: ${addResponse.status}`);
          }
          
          const cartData = await addResponse.json();
          console.log('Cart updated successfully with batch add:', cartData);
          return true;
        } catch (batchError) {
          console.warn('Batch add failed, trying individual adds:', batchError);
          // Try individual adds as fallback
          return await addItemsIndividually(items, commonProperties);
        }
      } catch (error) {
        console.error('Error updating cart:', error);
        alert(`There was an error adding items to your cart: ${error.message}`);
        return false;
      }
    }
    
    // Legacy function - now replaced
    async function clearCartAndAddItems(items, commonProperties) {
      console.warn('Legacy clearCartAndAddItems function called - using addItemsToCart instead');
      return addItemsToCart(items, commonProperties);
    }
    
    // Try to use the variant selector as a fallback
    function checkAndUseFallbackVariantSelector() {
      const productIdInput = document.querySelector('input[name="id"]');
      const variantSelector = document.getElementById('variant-selector');
      
      if (variantSelector && (!productIdInput || !productIdInput.value || productIdInput.value.trim() === '')) {
        console.log("Using variant selector fallback");
        
        // Get the first variant ID from the selector
        const variantId = variantSelector.value;
        
        if (variantId) {
          console.log("Found variant ID from fallback selector:", variantId);
          
          // Create or update the product ID input
          if (!productIdInput) {
            const newInput = document.createElement('input');
            newInput.type = 'hidden';
            newInput.name = 'id';
            newInput.value = variantId;
            
            const formElement = document.getElementById('bridal-shower-form');
            if (formElement) {
              formElement.appendChild(newInput);
            }
          } else {
            productIdInput.value = variantId;
          }
          
          // Also update the bridal-product-id input
          const bridalProductId = document.getElementById('bridal-product-id');
          if (bridalProductId) {
            bridalProductId.value = variantId;
          }
        }
      }
    }
  } catch (error) {
    console.error('Error initializing bridal shower form:', error);
  }
}); 